import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

// slices
import storeReducer from "./storeSlice";
import adminReducer from "./adminSlice";
import ownerReducer from "./ownerSlice";
import storeFormSlice from "./storeFormSlice";
import customerSlice from "./customerSlice";
import organizerSlice from "./organizerSlice";
import organizationSlice from "./organizationSlice";
import authSlice from "./authSlice";
import posOrderingReducer from "./posOrderingSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["store", "admin", "owner", "customer", "storeForm", "organizer", "organization", "auth", "posOrdering"],
};

const rootReducer = combineReducers({
  store: storeReducer,
  admin: adminReducer,
  owner: ownerReducer,
  customer: customerSlice,
  storeForm: storeFormSlice,
  organizer: organizerSlice,
  organization: organizationSlice,
  auth: authSlice,
  posOrdering: posOrderingReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
